import { render, staticRenderFns } from "./BehaviorProgressMonitoring.vue?vue&type=template&id=ad2853ac&scoped=true"
import script from "./BehaviorProgressMonitoring.vue?vue&type=script&lang=js"
export * from "./BehaviorProgressMonitoring.vue?vue&type=script&lang=js"
import style0 from "./BehaviorProgressMonitoring.vue?vue&type=style&index=0&id=ad2853ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2853ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VLayout,VListItem,VSpacer,VTab,VTabItem,VTabs})
